import { render } from "./record_wait_for_approve_visit.svg.vue?vue&type=template&id=b286b644"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__